class InvoicesPaymentCreateModalCtrl {

    constructor(invoice, Invoice, $uibModalInstance, Alert, PaymentsService) {
        this.givenInvoice = invoice;
        this.invoiceModel = Invoice;
        this.modalInstance = $uibModalInstance;
        this.alert = Alert;
        this.paymentsService = PaymentsService;
        this.types = [];
        this.states = [];

        this.model = {
            type: null,
            amount: parseFloat((this.givenInvoice.sum_brutto - this.givenInvoice.already_paid_amount).toFixed(2)),
            payment_time: new Date(),
            status: null
        };

        this.allowTypeChange = true;
        this.enableDelete = false;
        this.loadTypes();
        this.loadStates();
    }

    loadTypes() {
        this.paymentsService.getAllTypes().then((types) => {
            this.types = types;
            if(this.model.type === null) {
                this.model.type = this.types[0].key;
            }
        });
    }

    loadStates() {
        this.paymentsService.getAllStates().then((states) => {
            console.log('done', states);
            this.states = states;
            if(this.model.status === null) {
                this.model.status = this.states[0].key;
            }
        }, (e) => {
            console.log(e);
        });
    }


    save() {
        const dataForApi = _.cloneDeep(this.model);

        this.invoiceModel.one(this.givenInvoice.id).post('payments', dataForApi).then(() => {
            this.alert.success('Success', 'The payment was created');
            this.close();
        });
    }

    close() {
        this.modalInstance.close();
    }

    dismiss() {
        this.modalInstance.dismiss();
    }
}

InvoicesPaymentCreateModalCtrl.$inject = [
    'invoice',
    'Invoice',
    '$uibModalInstance',
    'Alert',
    'PaymentsService'
];

/**
 * @ngdoc object
 * @name billing.invoices:InvoicesPaymentCreateModalCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .controller('InvoicesPaymentCreateModalCtrl', InvoicesPaymentCreateModalCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/controllers/payments/create-modal-controller.js